module.exports = __webpack_public_path__ + "static/media/bg_login.ba2f9f13.png";